import MeetingNotesContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/MeetingNotesContent";
import InternalStakeholderAvailabilityEvent from "../event/InternalStakeholderAvailabilityEvent";
import InternalStakeholderDefinition from "./InternalStakeholderDefinition";
import InternalStakeholdersConfig from "./InternalStakeholdersConfig";

export default class InternalStakeholdersModel {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher
     * @param {InternalStakeholdersConfig} internalStakeholdersConfig 
     */
    constructor(dispatcher, internalStakeholdersConfig) {
        this._dispatcher = dispatcher;
        this._internalStakeholdersConfig = internalStakeholdersConfig;

        this._activeInternalStakeholders = [];
        this._contentByInternalStakeholderId = {};
    }

    setContentForInternalStakeholderId(internalStakeholderId, content) {
        this._contentByInternalStakeholderId[internalStakeholderId] = content;
    }

    getContentForInternalStakeholderId(internalStakeholderId) {
        return this._contentByInternalStakeholderId[internalStakeholderId];
    }

    /**
     * @param {InternalStakeholderDefinition} internalStakeholder 
     */
    activateInternalStakeholder(internalStakeholder) {
        if(!this._activeInternalStakeholders.some(is => is.id === internalStakeholder.id)) {
            this._activeInternalStakeholders.push(internalStakeholder);
        }
        const internalStakeholderAvailabilityEvent = new InternalStakeholderAvailabilityEvent(InternalStakeholderAvailabilityEvent.INTERNAL_STAKEHOLDER_AVAILABLE, internalStakeholder);
        this._dispatcher.dispatch(internalStakeholderAvailabilityEvent.type, { data: internalStakeholderAvailabilityEvent });
    }

    /**
     * @param {InternalStakeholderDefinition} internalStakeholder 
     */
    deactivateInternalStakeholder(internalStakeholder) {
        const activeInternalStakeholderIndex = this._activeInternalStakeholders.indexOf(internalStakeholder);
        this._activeInternalStakeholders.splice(activeInternalStakeholderIndex, 1);

        const internalStakeholderAvailabilityEvent = new InternalStakeholderAvailabilityEvent(InternalStakeholderAvailabilityEvent.INTERNAL_STAKEHOLDER_UNAVAILABLE, internalStakeholder);
        this._dispatcher.dispatch(internalStakeholderAvailabilityEvent.type, { data: internalStakeholderAvailabilityEvent });
    }

    /**
     * @param {InternalStakeholderDefinition} internalStakeholder 
     * @return {boolean}
     */
    internalStakeholderIsActive(internalStakeholder) {
        return this._activeInternalStakeholders.indexOf(internalStakeholder) > -1;
    }

    getInternalStakeholderById(internalStakeholderId) {
        return this.internalStakeholders.find(i => i.id === internalStakeholderId);
    }

    get activeInternalStakeholders() {
        return this._activeInternalStakeholders;
    }

    get internalStakeholders() {
        return this._internalStakeholdersConfig.internalStakeholders;
    }

    get internalStakeholderIds() {
        return this.internalStakeholders.map(i => i.id);
    }

    toObject() {
        return {
            activeInternalStakeholders: this._activeInternalStakeholders.map(t => t.toObject()),
            contentByInternalStakeholderId: objectToArray(this._contentByInternalStakeholderId),
        };
    }

    fromObject(obj, languagePack) {
        this._activeInternalStakeholders = obj.activeInternalStakeholders.map(t => InternalStakeholderDefinitionObject(t));
        this._contentByInternalStakeholderId = arrayToObject(obj.contentByInternalStakeholderId, languagePack);
    }
}


const InternalStakeholderDefinitionObject = function (obj) {
    const internalStakeholderDefinition = new InternalStakeholderDefinition();
    internalStakeholderDefinition.fromObject(obj);
    return internalStakeholderDefinition;
}

const objectToArray = function (object, languagePack) {
    const generatedArray = [];
    for (const property in object) {
        if (object.hasOwnProperty(property)) {
            const newObj = {
                id: property,
                content: object[property].convertToObject()
            };
            generatedArray.push(newObj);
        }
    }
    return generatedArray;
}

const arrayToObject = function (array, languagePack) {
    const originalObject = {};
    for (const obj of array) {
        const meetingNotesContent = new MeetingNotesContent(languagePack, null, null);
        meetingNotesContent.setPropertiesFromObject(obj.content);
        originalObject[obj.id] = meetingNotesContent;
    }
    return originalObject;
}